import { ZUSTAND_APP_STORE_LOCAL_STORAGE_KEY } from '@/config/consts'
import { useStore } from '@/domain/state'
import { CardEligibilityResult } from '../types/CardState'
import { checkCardEligibility } from '../hooks/useCardEligibility'

interface PersistedCardSessionEntry {
  hasRefreshSession?: boolean
}

function getPersistedByAddress(): Record<string, PersistedCardSessionEntry> | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(ZUSTAND_APP_STORE_LOCAL_STORAGE_KEY)
    if (!raw) return null
    const { state } = JSON.parse(raw)
    return state?.cardAuth?.byAddress ?? null
  } catch {
    return null
  }
}

function hasPersistedSessionForAddress(data: PersistedCardSessionEntry): boolean {
  return data.hasRefreshSession === true
}

export function hasPersistedCardSessionForAddress(address: string): boolean {
  const byAddress = getPersistedByAddress()
  if (!byAddress) return false
  const data = byAddress[address.toLowerCase()]
  if (!data) return false
  return hasPersistedSessionForAddress(data)
}

export async function attemptAutoResume(address?: string): Promise<CardEligibilityResult> {
  if (!useStore.persist.hasHydrated()) {
    await new Promise<void>((resolve) => {
      const unsub = useStore.persist.onFinishHydration(() => {
        unsub()
        resolve()
      })
    })
  }

  const { cardAuth } = useStore.getState()

  if (address) {
    cardAuth.setActiveAddress(address)
  }

  return checkCardEligibility()
}
